<template>
  <billing-report-panel
    report-key="production-insurance"
    route="/reports/billing-production-insurance"
    file-name="producao-por-convenio.xlsx"
    period-label="Período do atendimento"
    :columns="columns"
    :default-days="30"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Convênio',
        'Plano',
        'Itens',
        'Guias',
        'Valor em consulta',
        'Valor em SP/SADT',
        'Valor em guia simples',
        'Total do plano',
        'Subtotal por convênio',
      ],
    };
  },
};
</script>
